import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url, robots }) => {
  const siteName = 'Aashi Constructions';
  const defaultDescription = 'Quality construction services in Bangalore. 25+ years of expertise in residential and commercial construction.';
  const siteUrl = 'https://aashigroups.in';

  const seo = {
    title: title ? `${title} | ${siteName}` : siteName,
    description: description || defaultDescription,
    keywords: keywords || 'construction, bangalore, building, home construction, commercial construction',
    image: image || 'https://aashigroups.in/og-image.jpg',
    url: url ? `${siteUrl}${url}` : siteUrl,
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      {robots && <meta name="robots" content={robots} />}
      <link rel="canonical" href={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
    </Helmet>
  );
};

export default SEO;
